import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { user, logout, isAuthenticated, isAdmin } = useAuth();

  const navItems = [
    { path: '/', name: 'Home', icon: '🏠' },
    { path: '/log', name: 'Log Entry', icon: '📝' },
    { path: '/entries', name: 'View Entries', icon: '📊' },
    { path: '/insights', name: 'Insights', icon: '🧠' },
    { path: '/appointments', name: 'Appointments', icon: '👩‍⚕️' },
  ];

  if (isAdmin) {
    navItems.push({ path: '/admin', name: 'Admin', icon: '🔧' });
  }

  return (
    <nav className="nav-glass sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 group">
              <h1 className="text-xl font-bold text-gradient hover:scale-105 transition-transform duration-300">
                IBD Diary
              </h1>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-2">
            {isAuthenticated ? (
              <>
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`nav-link flex items-center space-x-2 text-sm ${
                      location.pathname === item.path
                        ? 'nav-link-active'
                        : 'text-neutral-600 hover:text-neutral-800'
                    }`}
                  >
                    <span className="text-base">{item.icon}</span>
                    <span>{item.name}</span>
                  </Link>
                ))}
                <div className="flex items-center space-x-4 ml-4 pl-4 border-l border-white/20">
                  <span className="text-sm text-neutral-600 font-medium">
                    Welcome, <span className="text-gradient-soft font-semibold">{user?.username}</span>
                  </span>
                  <button
                    onClick={logout}
                    className="btn-secondary text-xs px-4 py-2 text-red-600 hover:text-red-700 hover:bg-red-50/50"
                  >
                    Logout
                  </button>
                </div>
              </>
            ) : (
              <div className="flex items-center space-x-3">
                <Link
                  to="/login"
                  className="nav-link text-sm text-neutral-600 hover:text-neutral-800"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="btn-primary text-sm px-4 py-2"
                >
                  Register
                </Link>
              </div>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 rounded-2xl text-neutral-500 hover:text-neutral-700 hover:bg-glass-white transition-all duration-200 hover:scale-105"
            >
              <svg
                className="h-6 w-6 transition-transform duration-200"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
                style={{ transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)' }}
              >
                {isOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden border-t border-white/20">
            <div className="px-4 pt-4 pb-6 space-y-2 bg-glass-white backdrop-blur-xl">
              {isAuthenticated ? (
                <>
                  {navItems.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      onClick={() => setIsOpen(false)}
                      className={`nav-link flex items-center space-x-3 w-full text-left ${
                        location.pathname === item.path
                          ? 'nav-link-active'
                          : 'text-neutral-600 hover:text-neutral-800'
                      }`}
                    >
                      <span className="text-lg">{item.icon}</span>
                      <span className="font-medium">{item.name}</span>
                    </Link>
                  ))}
                  <div className="border-t border-white/20 pt-4 mt-4">
                    <div className="px-3 py-2">
                      <p className="text-sm text-neutral-600 font-medium mb-3">
                        Welcome, <span className="text-gradient-soft font-semibold">{user?.username}</span>
                      </p>
                      <button
                        onClick={() => {
                          logout();
                          setIsOpen(false);
                        }}
                        className="w-full btn-secondary text-red-600 hover:text-red-700 hover:bg-red-50/50"
                      >
                        Logout
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <div className="space-y-3">
                  <Link
                    to="/login"
                    onClick={() => setIsOpen(false)}
                    className="nav-link block w-full text-center text-neutral-600 hover:text-neutral-800"
                  >
                    Login
                  </Link>
                  <Link
                    to="/register"
                    onClick={() => setIsOpen(false)}
                    className="btn-primary block w-full text-center"
                  >
                    Register
                  </Link>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;